import React, { useContext, useEffect, useRef, useState } from 'react';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import antMessage from '../../../utils/extend/AntdNotification';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { Alert, Button, Col, Dropdown, Form, Input, InputNumber, Modal, Popconfirm, Row, Select, Space, Switch, Tag, Tooltip } from 'antd';
import MenuFoodEdit from '../menu/MenuFoodEdit';
// import MenuOPLog from '../menu/MenuOPLog';
import MenuCondiment from '../menu/MenuCondiment';
import MenuSpec from './MenuSpec';
import MenuShopType from './MenuShopType';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import objectHandle from '../../../utils/baseLib/objectHandle';
import WarehouseToMenu from '../menu/WarehouseToMenu';
import MenuSaleDate from '../menu/MenuSaleDate';
import MenuSalesman from '../menu/MenuSalesman';
// import MenuSpecSpecial from './MenuSpecSpecial';
import { SocketContext } from '../../../App';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import arrayHandle from '../../../utils/baseLib/arrayHandle';
import { PlusOutlined } from '@ant-design/icons';

//组件 ShowMenu
export default function ShowMenu(props: any) {

    const ref = useRef<any>(undefined);
    const [form] = Form.useForm();
    const [batchOperationForm] = Form.useForm();

    const { closeModal, data } = props;
    const notificationApi = useNotificationInstance()

    //规格窗口
    const [menuSpecVisible, setMenuSpecVisible] = useState(false);

    //调整小分类窗口
    const [shopTypeVisible, setShopTypeVisible] = useState(false);

    //添加推广菜式窗口
    const [menuToPromoVisible, setMenuToPromoVisible] = useState(false);

    //规格数据
    const [specData, setSpecData] = useState<any>();

    //设置加料窗口
    const [menuCondimentVisible, setMenuCondimentVisible] = useState(false);

    //设置加料数据
    const [menuCondimentData, setMenuCondimentData] = useState<any>();

    //设置操作日志窗口
    // const [menuOPLogVisible, setMenuOPLogVisible] = useState(false);

    //设置操作日志数据
    // const [menuOPLogData, setMenuOPLogData] = useState<any>();

    //小分类数据
    const [menuShopTypeData, setMenuShopTypeData] = useState<any>();

    //推广数据
    const [menuToPromoData, setMenuToPromoData] = useState<any>();

    //销售 / 折扣时间窗口
    const [menuSaleDateVisible, setMenuSaleDateVisible] = useState(false);

    //销售 / 折扣时间数据
    const [menuSaleDateData, setMenuSaleDateData] = useState<any>();

    //销售人员销售菜式窗口
    const [menuSalesmanVisible, setMenuSalesmanVisible] = useState(false);

    //销售人员销售菜式数据
    const [menuSalesmanData, setMenuSalesmanData] = useState<any>();

    const [shopTypeNewData, setShopTypeNewData] = useState<any>();
    const [shopTypeData, setShopTypeData] = useState<any>();
    const [shopTypeIdData, setShopTypeIdData] = useState<any>();

    const [menuHeadData, setMenuHeadData] = useState<any>();

    //迁移窗口
    const [showTransferVisible, setShowTransferVisible] = useState(false);

    const [menuMemoTags, setMenuMemoTags] = useState(['']);
    const [inputMemoVisible, setInputMemoVisible] = useState<any>(false);
    const [inputMemoValue, setInputMemoValue] = useState<any>('');
    const [editInputMemoIndex, setEditInputMemoIndex] = useState<any>(-1);
    const [editInputMemoValue, setEditInputMemoValue] = useState<any>('');

    //批量操作窗口
    const [showBatchOperationVisible, setShowBatchOperationVisible] = useState(false);

    //当前的批量操作方式
    const [currentBatchOperation, setCurrentBatchOperation] = useState<any>();
    const [discountData, setDiscountData] = useState<boolean>(true);

    const [loadingData, setLoadingData] = useState<any>(false);

    /**选中的所有数据 */
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const batchOperations = [
        {
            key: 'changeStateToTrue',
            // label: '上架',
            // label: (<Popconfirm
            //     title="确定要执行批量上架操作吗？"
            //     onConfirm={() => handleConfirm(true)}
            //     okText="确定"
            //     cancelText="取消"
            // >上&nbsp;&nbsp;&nbsp;&nbsp;架
            // </Popconfirm>),
            label: selectedRowKeys.length > 0 ? '上架' : (<Tooltip title="请先选择菜品" key="leftButton">
                上架
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'changeStateToFalse',
            // label: '下架',
            // label: (<Popconfirm
            //     title="确定要执行批量下架操作吗？"
            //     onConfirm={() => handleConfirm(false)}
            //     okText="确定"
            //     cancelText="取消"
            // >下&nbsp;&nbsp;&nbsp;&nbsp;架
            // </Popconfirm>),
            label: selectedRowKeys.length > 0 ? '下架' : (<Tooltip title="请先选择菜品" key="leftButton">
                下架
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'changeShopType',
            // label: '改分类',
            label: selectedRowKeys.length > 0 ? '改分类' : (<Tooltip title="请先选择菜品" key="leftButton">
                改分类
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'changeDiscount',
            // label: '设折扣',
            label: selectedRowKeys.length > 0 ? '设折扣' : (<Tooltip title="请先选择菜品" key="leftButton">
                设折扣
            </Tooltip>)
            // disabled: true,
        },
        {
            key: 'createMenuMemo',
            // label: '加备注',
            label: selectedRowKeys.length > 0 ? '加备注' : (<Tooltip title="请先选择菜品" key="leftButton">
                加备注
            </Tooltip>)
            // disabled: true,
        },
    ];

    /** api服务id */
    const apiId = 'menu';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    const useContextData = useContext(SocketContext);
    const { contextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }

        //同步获取数据 async - await
        const fetchData = async () => {

            form.setFieldsValue({ menuMemo: [] });

            fetchApi.GET(wmService, {
                apiId: "menuShopType",
                apiExtend: 'showShopTypeList',
                apiData: {
                    menuHeadId: data.menuHeadId,
                    // branchStoreId: localStorage.getItem("currentBranchStoreId"),
                    branchStoreId: contextData?.currentBranchStoreId,
                    mountDataOptions: {
                        userMount: {
                            isDept: true
                        }
                    }
                }
            }).then(res => {
                if (res.success) {
                    let newData = [{ id: "999", shopTypeName: "所有分类" }, ...res.data];
                    setShopTypeData(newData);
                }
            })
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    const newShopTypeData = (rows: any, setData: any) => {
        let newSelectData: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            newSelectData.push({
                value: rows[j].id,
                label: rows[j].shopTypeName,
                shopType_shortCode: rows[j].shopType_shortCode,
            })
        }
        setData(newSelectData);
    }

    //打开规格
    const handleMenuSpec = (record: any) => {
        // console.log(record)
        sendData.key = data.key;
        sendData.menuId = record.id;
        sendData.foodName = record.foodName;
        // sendData.menuWarehouseId = record.menuWarehouseId;
        sendData.branchStoreMenuWarehouseId = record.branchStoreMenuWarehouseId;
        sendData.foodType = record.branchStoreMenuWarehouse.foodType;
        setSpecData(sendData);
        setMenuSpecVisible(true);
    };

    //打开设置加料
    const handleMenuCondiment = (record: any) => {
        //console.log(record);
        sendData.menuId = record.id;
        sendData.foodName = record.foodName;
        sendData.branchStoreMenuWarehouseId = record.branchStoreMenuWarehouseId;
        setMenuCondimentData(sendData);
        setMenuCondimentVisible(true);
    };

    //打开操作日志
    // const handleMenuOPLog = (record: any) => {
    //     // console.log(record);
    //     sendData.menuId = record.id;
    //     sendData.foodName = record.foodName;
    //     sendData.isModal = true;
    //     setMenuOPLogData(sendData);
    //     setMenuOPLogVisible(true);
    // };

    //查看不同分类的菜式
    const shopTypeChange = (e: any) => {

        setShopTypeIdData(e);
        const menuHeadId = data.menuHeadId;
        const currentData: initDataType = {
            apiId,
            sendPageData: { shopTypeId: e, menuHeadId: menuHeadId }
        }
        ref.current.initData(currentData);
    }

    //分类选择
    const shopTypeSelect = (e: any, option: any) => {
        batchOperationForm.setFieldsValue({ shopType_shortCode: option.shopType_shortCode });
        batchOperationForm.setFieldsValue({ shopTypeName: option.label });
    }

    //检查单位
    // const checkProductUnit = async (rows: any) => {

    //     let menuSpecData = [];
    //     for (var i = 0, len = rows.length; i < len; i++) {
    //         menuSpecData.push(rows[i].menuSpecName);
    //     }

    //     let returnData = await fetchApi.GET(wmService, {
    //         apiId: "menu",
    //         apiExtend: 'checkProductUnit',
    //         apiData: {
    //             menuSpecData
    //         }
    //     })
    //     // if (aa.data) {
    //     //     num = num + 1
    //     // }
    //     return returnData.data;
    // };

    //打开销售/折扣周期页面
    const handleMenuSaleDate = (record: any) => {
        //console.log(record)
        sendData.targetId = record.id;
        sendData.targetKey = 'menu';
        sendData.title = record.foodName;
        setMenuSaleDateData(sendData);
        setMenuSaleDateVisible(true);
    };

    //关闭销售/折扣周期页面
    const onCloseMenuSaleDate = async (status: boolean) => {
        setMenuSaleDateVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开销售时段页面
    const handleMenuSalesman = () => {
        sendData.menuHeadId = data.menuHeadId;
        setMenuSalesmanData(sendData);
        setMenuSalesmanVisible(true);
    };

    //关闭销售时段页面
    const onCloseMenuSalesman = async (status: boolean) => {
        setMenuSalesmanVisible(false);
        // if (status) {
        //     await initData();
        // }
    }

    //改变数据
    const handleChange = async (id: any, columnName: string, isValue: boolean) => {
        const bodys = {
            apiId: "menu",
            apiVariable: id,
            apiExtend: "updateSingle",
            apiData: {
                columnName,
                isValue
            }
        }
        fetchApi.PUT(wmService, bodys).then(res => {
            showCustomNotification(notificationApi!, {
                type: 'success',
                message: '编辑成功',
                description: 'success',
            });;
            initData();
        }).catch(err => {
            antMessage('error', '删编辑失败', err.message);
        })
    };

    //记录选中的菜式Id
    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    //处理批量操作
    const handleBatchOperation = (e: any) => {
        // console.log('click', e);
        // console.log("selectedRowKeys");
        // console.log(selectedRowKeys);
        // console.log("---------------------------");
        switch (e.key) {
            //批量改分类
            case "changeShopType":
                // console.log("这是批量改分类");
                if (selectedRowKeys.length > 0) {
                    fetchApi.GET(wmService, {
                        apiId: "menuShopType",
                        apiExtend: 'showShopTypeList',
                        apiData: {
                            menuHeadId: data.menuHeadId,
                            branchStoreId: contextData?.currentBranchStoreId,
                            mountDataOptions: {
                                userMount: {
                                    isDept: true
                                }
                            }
                        }
                    }).then(res => {
                        if (res.success) {
                            newShopTypeData(res.data, setShopTypeNewData);
                        }
                    })

                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation(e.key);
                    batchOperationForm.setFieldsValue({ key: e.key });
                }
                break;

            //批量上架
            case "changeStateToTrue":
                // console.log("这是批量上架");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("changeState");
                    batchOperationForm.setFieldsValue({ key: "changeState" });
                    batchOperationForm.setFieldsValue({ isUse: true });
                }
                break;

            //批量下架
            case "changeStateToFalse":
                // console.log("这是批量下架");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation("changeState");
                    batchOperationForm.setFieldsValue({ key: "changeState" });
                    batchOperationForm.setFieldsValue({ isUse: false });
                }
                break;

            //批量设折扣
            case "changeDiscount":
                // console.log("这是批量设折扣");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation(e.key);
                    batchOperationForm.setFieldsValue({ key: e.key });
                }
                break;

            //批量加备注
            case "createMenuMemo":
                // console.log("这是批量加备注");
                if (selectedRowKeys.length > 0) {
                    setShowBatchOperationVisible(true);
                    setCurrentBatchOperation(e.key);
                    batchOperationForm.setFieldsValue({ key: e.key });
                }
                break;
        }
    };

    const showInputMemo = () => {
        setInputMemoVisible(true);
    };

    const handleInputMemoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputMemoValue(e.target.value);
    };

    const handleInputMemoConfirm = () => {
        if (inputMemoValue && menuMemoTags.indexOf(inputMemoValue) === -1) {
            setMenuMemoTags([...menuMemoTags, inputMemoValue]);
            batchOperationForm.setFieldsValue({ menuMemo: [...menuMemoTags, inputMemoValue] });
        }
        setInputMemoVisible(false);
        setInputMemoValue('');
    };

    const handleEditInputMemoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditInputMemoValue(e.target.value);
    };

    const handleCloseMemoTag = (removedTag: string) => {
        const newTags = menuMemoTags.filter((tag) => tag !== removedTag);
        setMenuMemoTags(newTags);
        batchOperationForm.setFieldsValue({ menuMemo: newTags });
    };

    const handleEditInputMemoConfirm = () => {
        const newTags = [...menuMemoTags];
        newTags[editInputMemoIndex] = editInputMemoValue;
        setMenuMemoTags(newTags);
        batchOperationForm.setFieldsValue({ menuMemo: newTags });
        setEditInputMemoIndex(-1);
        setInputMemoValue('');
    };

    /** 控制Switch */
    const handleSwitch = (e: any, setData: any) => {
        setData(!e);
    };

    const batchOperationOk = (e: any) => {
        batchOperationForm.validateFields() //数据校验
            .then(async (values: any) => {
                setLoadingData(true);
                fetchApi.PUT(wmService, {
                    apiId,
                    apiExtend: "batchOperation",
                    apiData: {
                        ...values,
                        apiId,
                        branchStoreId: contextData?.currentBranchStoreId,
                        menuIds: selectedRowKeys,
                        mountDataOptions: {
                            userMount: {
                                isDept: true
                            }
                        },
                    }

                }).then(async res => {
                    if (res.success) {
                        setLoadingData(false);
                        antMessage('success', '添加成功', 'success');
                        onCloseBatchOperation();
                        setSelectedRowKeys([]);
                        await initData();
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            }).catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    const handleOk = (e: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                setLoadingData(true);
                fetchApi.PUT(wmService, {
                    apiId: "menu",
                    apiExtend: 'copy',
                    apiData: {
                        ...values,
                        key: "transfer"
                    }
                }).then(res => {
                    if (res.success) {
                        setLoadingData(false);
                        antMessage('success', '添加成功', 'success');
                        onCloseTransfer();

                        const menuHeadId = data.menuHeadId;
                        const currentData: initDataType = {
                            apiId,
                            sendPageData: { menuHeadId: menuHeadId }
                        }
                        ref.current.initData(currentData);
                    }
                }).catch(err => {
                    antMessage('error', '错误，无法保存', err.message + ' | status:' + err.errors.status);
                })
            }).catch((err: any) => {
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: "请输入所需数据!"
                });
            });
    };

    const handleCancel = (e: any) => {
        closeModal(false);
    };

    const initData = async () => {
        const menuHeadId = data.menuHeadId;
        const promoCategoryId = data.promoCategoryId;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                shopTypeId: shopTypeIdData,
                menuHeadId: menuHeadId,
                promoCategoryId: promoCategoryId
            }
        }
        ref.current.initData(currentData);
    }

    //关闭调整类别顺序窗口
    const onCloseMenuShopType = async (status: boolean) => {
        setShopTypeVisible(false)
        if (status) {
            await initData();
        }
    }

    //关闭菜式规格窗口
    const onCloseMenuSpec = async (status: boolean) => {
        setMenuSpecVisible(false)
        if (status) {
            await initData();
        }
    }

    //调整类别顺序
    const handleShopTypeSortBy = () => {
        sendData.menuHeadId = data.menuHeadId;
        sendData.menuHeadName = data.menuHeadName;
        setMenuShopTypeData(sendData);
        setShopTypeVisible(true);
    };

    //添加推广菜式
    const handlePromoFood = () => {
        sendData.key = data.key;
        sendData.promoCategoryId = data.promoCategoryId;
        sendData.promoCategoryName = data.promoCategoryName;
        sendData.banquetId = data.banquetId;
        sendData.brandId = data.brandId;
        sendData.brandName = data.brandName;
        sendData.branchStoreId = data.branchStoreId;
        sendData.branchStoreName = data.branchStoreName;

        setMenuToPromoData(sendData);
        setMenuToPromoVisible(true);
    };

    //关闭穿梭框页面
    const onCloseMenuToPromo = async (status: boolean) => {
        setMenuToPromoVisible(false);
        if (status) {
            await initData();
        }
    }

    //自动更新菜式排序
    const handleMenuSortBy = () => {
        fetchApi.PUT(wmService, {
            apiId: "menu",
            apiExtend: 'changeSortBy',
            apiData: {
                menuHeadId: data.menuHeadId
            }
        }).then(res => {
            if (res.success === true) {
                const menuHeadId = data.menuHeadId;
                const currentData: initDataType = {
                    apiId,
                    sendPageData: { menuHeadId: menuHeadId }
                }
                ref.current.initData(currentData);
            }
        })
    };

    //关闭批量操作窗口
    const onCloseBatchOperation = () => {
        setShowBatchOperationVisible(false);
        batchOperationForm.setFieldsValue({ shopTypeId: null });
        batchOperationForm.setFieldsValue({ shopTypeName: null });
        batchOperationForm.setFieldsValue({ shopType_shortCode: null });
        batchOperationForm.setFieldsValue({ menuMemo: null });
        setMenuMemoTags([]);
        batchOperationForm.setFieldsValue({ isDiscount: false });
        batchOperationForm.setFieldsValue({ maxDiscount: 1 });
        setDiscountData(true);
    }

    //关闭迁移窗口
    const onCloseTransfer = () => {
        setShowTransferVisible(false);
        form.setFieldsValue({ menuHeadId: null });
    }

    //迁移菜式
    const handleTransfer = (record: any) => {
        // console.log(record);
        fetchApi.GET(wmService, {
            apiId: "menuHead",
            apiExtend: 'showList',
            apiData: {
                branchStoreId: contextData?.currentBranchStoreId,
                mountDataOptions: {
                    userMount: {
                        isDept: true
                    }
                },
            }
        }).then(res => {
            if (res.success) {
                newMenuHeadData(res.data, record.branchStoreMenuWarehouseId, setMenuHeadData, true);

                // let newSelectData: Array<any> = [];
                // for (var j = 0; j < res.data.length; j++) {
                //     newSelectData.push({
                //         value: res.data[j].id,
                //         label: res.data[j].menuHeadName,
                //         disabled: res.data[j].id === record.menuHeadId ? true : false
                //     })
                // }

                // setMenuHeadData(newSelectData);
            }
        });

        form.setFieldsValue({ currentMenuId: record.id });
        setShowTransferVisible(true);
    };

    const newMenuHeadData = async (rows: any, branchStoreMenuWarehouseId: string, setData: any, key: any) => {
        let newSelectData: Array<any> = [];
        for (var j = 0; j < rows.length; j++) {
            const res = await fetchApi.GET(wmService, {
                apiId: 'menu',
                apiExtend: 'checkMenu',
                apiData: {
                    branchStoreMenuWarehouseId,
                    menuHeadId: rows[j].id
                }
            })
            newSelectData.push({
                value: rows[j].id,
                label: rows[j].menuHeadName,
                disabled: res.data.length > 0 ? key : !key
            })
        }
        setData(newSelectData);
    }

    //复制菜式
    const handleCopy = (record: any) => {
        fetchApi.PUT(wmService, {
            apiId: "menu",
            apiExtend: 'copy',
            apiData: {
                key: "copy",
                menu: record
            }
        }).then(res => {
            if (res.success === true) {
                const menuHeadId = data.menuHeadId;
                const currentData: initDataType = {
                    apiId,
                    sendPageData: { menuHeadId: menuHeadId }
                }
                ref.current.initData(currentData);
            }
        })
    };

    //表头
    const columnsHead = [
        {
            title: '菜式',
            dataIndex: 'foodName',
            render: (text: any, record: any) => {
                return (
                    <div>
                        <Space size="small">
                            {data.key === 'menuToPromo' ? "" : record.isCopy ? "" :
                                <Space>
                                    <Button type='primary' size={"small"} onClick={() => handleTransfer(record)}>迁移到</Button>
                                    <Popconfirm title="复制一个相同的菜式,是否执行?" onConfirm={() => handleCopy(record)}>
                                        <Button type='primary' size={"small"}>复制</Button>
                                    </Popconfirm>
                                </Space>
                            }
                            <Tooltip placement="topLeft" title={'对应的门店菜式为【 ' + record.branchStoreMenuWarehouse.foodName + ' 】'}>
                                <div>{record.foodName}</div>
                            </Tooltip>
                        </Space>
                    </div>
                )
            }
        },

        data.key === 'menuToPromo' ?
            {
                title: '菜谱类型',
                dataIndex: 'menuHeadName',
                render: (text: any, record: any) => (
                    <div>{record.menuHead.menuHeadName}</div>
                )
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '类别',
                dataIndex: 'shopTypeName',
                render: (text: any, record: any) => {
                    if (record.shopType) {
                        return (
                            <div>{record.shopType.shopTypeName}</div>
                        )
                    }
                }
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '单位',
                dataIndex: 'productUnitName',
                width: 150,
                render: (text: any, record: any) => {
                    // console.log(record);
                    if (record.checkProductUnit === record.menuSpecs.length && record.menuSpecs.length === 1) {
                        // 只有一个规格，而且规格和检查单位数量相同

                        if (objectHandle.isEmpty(record.branchStoreMenuWarehouse.productUnit) === false) {
                            // 单位不为空

                            if (record.menuSpecs[0].menuSpecName !== record.branchStoreMenuWarehouse.productUnit.productUnitName) {
                                // 单位和规格不同 (单位应该和规格相同)

                                return (
                                    <p>
                                        {record.branchStoreMenuWarehouse.productUnit.productUnitName}
                                        <div style={{ color: 'red' }}>单位和规格不同，请检查</div>
                                    </p>
                                )
                            }
                            else {
                                // 单位和规格相同 (正确操作)

                                if (record.branchStoreMenuWarehouse.productUnit) {
                                    return (
                                        <div>{record.branchStoreMenuWarehouse.productUnit.productUnitName}</div>
                                    )
                                }
                            }
                        }
                    }

                    if (record.checkProductUnit !== record.menuSpecs.length && record.menuSpecs.length === 1) {
                        // 只有一个规格，但规格和检查单位数量不相同 (单位和规格正常是要相同的)

                        if (record.checkProductUnit === 0) {
                            //唯一的规格都不是单位

                            if (!record.isPrintSpec) {
                                //没有选上打印规格
                                return (
                                    <p>
                                        <div style={{ color: 'red' }}>唯一的规格并不是单位，请检查打印规格是否选上</div>
                                    </p>
                                )
                            }
                            else {
                                //选了打印规格
                                if (record.branchStoreMenuWarehouse.productUnit) {
                                    return (
                                        <div>{record.branchStoreMenuWarehouse.productUnit.productUnitName}</div>
                                    )
                                }
                                else {
                                    return (
                                        <p>
                                            <div style={{ color: 'red' }}>唯一的规格不是单位，请检查单位是否有写上</div>
                                        </p>
                                    )
                                }
                            }
                        }
                    }

                    if (record.checkProductUnit === record.menuSpecs.length && record.menuSpecs.length > 1) {
                        // 有多个规格，而且规格全是单位

                        if (objectHandle.isEmpty(record.branchStoreMenuWarehouse.productUnit) === false) {
                            // 有多个规格，单位不为空 (单位应该为空)

                            return (
                                <p>
                                    {record.branchStoreMenuWarehouse.productUnit.productUnitName}
                                    <div style={{ color: 'red' }}>有多个规格，请检查单位</div>
                                </p>
                            )
                        }
                        else {
                            // 有多个规格，单位为空 (正确操作)
                            if (record.branchStoreMenuWarehouse.productUnit) {
                                return (
                                    <div>{record.branchStoreMenuWarehouse.productUnit.productUnitName}</div>
                                )
                            }
                        }
                    }

                    if (record.checkProductUnit !== record.menuSpecs.length && record.menuSpecs.length > 1) {
                        // 有多个规格，规格不全是单位 (单位应该要写的)

                        if (record.checkProductUnit === 0) {
                            //全部规格都不是单位

                            if (!record.isPrintSpec) {
                                //没有选上打印规格
                                return (
                                    <p>
                                        <div style={{ color: 'red' }}>有多个规格但不是单位，请检查打印规格是否选上</div>
                                    </p>
                                )
                            }
                            else {
                                //选了打印规格
                                if (record.branchStoreMenuWarehouse.productUnit) {
                                    return (
                                        <div>{record.branchStoreMenuWarehouse.productUnit.productUnitName}</div>
                                    )
                                }
                                else {
                                    return (
                                        <p>
                                            <div style={{ color: 'red' }}>有多个规格但不是单位，请检查单位是否有写上</div>
                                        </p>
                                    )
                                }
                            }
                        }
                        else {
                            //部分规格都不是单位
                            return (
                                <p>
                                    <div style={{ color: 'red' }}>有些规格是单位有些不是单位，请检查</div>
                                </p>
                            )
                        }
                    }
                }
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '销售/折扣周期',
                dataIndex: 'menuSaleDate',
                key: 'menuSaleDate',
                render: (text: any, record: any) => {
                    if (record.branchStoreMenuWarehouse.foodType !== 'setMeal') {
                        if (record.menuSaleDates) {
                            return (
                                <Space size="small">
                                    <Button size={"small"} type="primary" onClick={() => handleMenuSaleDate(record)}>销售/折扣周期</Button>
                                </Space>
                            )
                        }
                        else {

                            return (
                                <Space size="small">
                                    <Button size={"small"} type="primary" danger onClick={() => handleMenuSaleDate(record)}>销售/折扣周期</Button>
                                </Space>
                            )
                        }
                    }
                }
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '加料',
                dataIndex: 'menuComdiment',
                key: 'menuComdiment',
                render: (text: any, record: any) => {
                    if (record.branchStoreMenuWarehouse.foodType !== 'setMeal') {
                        return (
                            <Space size="small">
                                <Button size={"small"} type="primary" onClick={() => handleMenuCondiment(record)}>加料</Button>
                            </Space>
                        )
                    }
                }
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '价格',
                dataIndex: 'price',
                render: (text: any, record: any) => {
                    if (record.menuSpecs.length > 0) {
                        return (
                            <div style={{ fontSize: 20, color: localStorage.getItem("themeMode") === '1' ? 'yellow' : 'red' }}>
                                {record.menuSpecs.length === 1 ? record.menuSpecs[0].price : arrayHandle.sort(record.menuSpecs, "price", "asc")[0].price + " - " + arrayHandle.sort(record.menuSpecs, "price", "asc")[record.menuSpecs.length - 1].price}
                            </div>
                        )
                    }
                }
            } : {},

        {
            title: '规格',
            dataIndex: 'menuSpec',
            key: 'menuSpec',
            render: (text: any, record: any) => {
                return (
                    <Space size="small">
                        <Button size={"small"} type="primary" onClick={() => handleMenuSpec(record)}>规格</Button>
                    </Space>
                )
            }
        },

        data.key !== 'menuToPromo' ?
            {
                title: '排序',
                dataIndex: 'sortBy',
            } : {},

        // data.key !== 'menuToPromo' ?
        //     {
        //         title: '日志',
        //         dataIndex: 'menuOPLog',
        //         render: (text: any, record: any) => {
        //             return (
        //                 <Space size="small">
        //                     <Button size={"small"} type="primary" onClick={() => handleMenuOPLog(record)}>日志</Button>
        //                 </Space>
        //             )
        //         }
        //     } : {},

        data.key !== 'menuToPromo' ?
            sessionStorage.getItem('isAdmin') === 'true' ?
                {
                    title: '特殊显示',
                    dataIndex: 'isSpecialShow',
                    render: (text: any, record: any) => (
                        <Switch checkedChildren="显示" unCheckedChildren="不显示"
                            checked={text} key={record.id}
                        // onChange={(e) => handleChange(record.id, 'isSpecialShow', e)}
                        />
                    )
                } : {} : {},

        data.key !== 'menuToPromo' ?

            {
                title: '打印规格',
                dataIndex: 'isPrintSpec',
                render: (text: any, record: any) => (
                    <Switch checkedChildren="打印" unCheckedChildren="不打印"
                        checked={text} key={record.id}
                    // onChange={(e) => handleChange(record.id, 'isPrintSpec', e)}
                    />
                )
            } : {},

        // {
        //     title: '客服专用',
        //     dataIndex: 'isStaff',
        //     render: (text: any, record: any) => (
        //         <Switch checkedChildren="是" unCheckedChildren="否"
        //             checked={text} key={record.id}
        //             onChange={(e) => handleChange(record.id, 'isStaff', e)}
        //         />
        //     )
        // },

        data.key !== 'menuToPromo' ?
            {   //该项原来是客服专用，后来发现和小程序显示有点冲突，故目前两个合二为一，先暂停小程序显示，以客服专用暂时叫小程序显示
                title: '客人查看',
                dataIndex: 'isStaff',
                render: (text: any, record: any) => (
                    <Switch checkedChildren="不显示" unCheckedChildren="显示"
                        checked={text} key={record.id}
                        onChange={(e) => handleChange(record.id, 'isStaff', e)}
                    />
                )
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '客人下单',
                dataIndex: 'isWx',
                render: (text: any, record: any) => (
                    <Switch checkedChildren="允许" unCheckedChildren="不允许"
                        checked={text} key={record.id}
                        onChange={(e) => handleChange(record.id, 'isWx', e)}
                    />
                )
            } : {},

        data.key !== 'menuToPromo' ?
            {
                title: '打折',
                dataIndex: 'isDiscount',
                render: (text: any, record: any) => {
                    if (record.isDiscount) {
                        return (
                            <Tooltip placement="topLeft" title={'当前折扣为 ' + record.maxDiscount} color='red'>
                                <Switch checkedChildren="是" unCheckedChildren="否"
                                    checked={text} key={record.id}
                                />
                            </Tooltip>
                        )
                    }
                    else {
                        return (
                            <Switch checkedChildren="是" unCheckedChildren="否"
                                checked={text} key={record.id}
                            />
                        )
                    }
                }
            } : {},

        data.key === 'menuToPromo' ?
            {
                title: '推广',
                dataIndex: 'isPromo',
                render: (text: any, record: any) => (
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                        onChange={(e) => handleChange(record.id, 'isPromo', e)}
                    />
                )
            } : {},

        // {
        //     title: '外卖',
        //     dataIndex: 'isWm',
        //     render: (text: any, record: any) => (
        //         <Switch checkedChildren="是" unCheckedChildren="否"
        //             checked={text} key={record.id}
        //             onChange={(e) => handleChange(record.id, 'isWm', e)}
        //         />
        //     )
        // },: {},

        data.key !== 'menuToPromo' ?
            {
                title: '状态',
                dataIndex: 'isUse',
                render: (text: any, record: any) => {
                    if (sessionStorage.getItem('isAdmin') === 'true') {
                        return (
                            <Switch checkedChildren="启用" unCheckedChildren="不启用"
                                checked={text} key={record.id}
                                onChange={(e) => handleChange(record.id, 'isUse', e)}
                            />
                        )
                    }
                    else {
                        return (
                            <Switch checkedChildren="启用" unCheckedChildren="不启用"
                                checked={text} key={record.id}
                            />
                        )
                    }
                }
            } : {},
    ];

    /** 子表头内容 */
    const expandableColumnsHead: Array<any> = [
        // {
        //     title: "id",
        //     dataIndex: "branchStoreMenuWarehouseSpecName",
        //     render: (text: any, record: any) => {
        //         return <>
        //             {record.id}
        //         </>
        //     }
        // },
        {
            title: "规格",
            dataIndex: "menuSpecName",
            render: (text: any, record: any) => {
                return <>
                    {objectHandle.isEmpty(record.otherUnit) === false ? record.menuSpecName + "(" + record.otherUnit + ")" : record.menuSpecName}
                </>
            }
        },
        {
            title: "价格",
            dataIndex: "price",
            render: (text: any, record: any) => {
                return <>
                    {record.price}
                </>
            }
        },
        // {
        //     title: "活动价",
        //     dataIndex: "promotionPrice",
        //     render: (text: any, record: any) => {
        //         return <>
        //             {record.promotionPrice}
        //         </>
        //     }
        // },
        {
            title: "限购数量",
            dataIndex: "limit",
            render: (text: any, record: any) => {
                return <>
                    {record.limit}
                </>
            }
        },
        {
            title: "起卖数",
            dataIndex: "minAmount",
            render: (text: any, record: any) => {
                return <>
                    {record.minAmount}
                </>
            }
        },
        {
            title: "增减量",
            dataIndex: "step",
            render: (text: any, record: any) => {
                return <>
                    {record.step}
                </>
            }
        },
        // {
        //     title: "排序",
        //     dataIndex: "sortBy",
        //     render: (text: any, record: any) => {
        //         return <>
        //             {record.sortBy}
        //         </>
        //     }
        // },
    ]

    /** 子表头 */
    const expandableColumns = expandableColumnsHead;
    const columns = columnsheadId
        .concat(columnsHead as []);

    //传关参数
    let sendData = {
        type: 'EDIT',
        menuId: '',
        title: '',
        targetId: '',
        targetKey: '',
        foodName: '',
        // menuWarehouseId: '',
        menuHeadId: '',
        menuHeadName: '',
        branchStoreMenuWarehouseId: '',
        foodType: '',
        isModal: false,

        //从推广分类传过来用的
        key: '',
        promoCategoryId: '',
        promoCategoryName: '',
        banquetId: '',
        brandId: '',
        brandName: '',
        branchStoreId: '',
        branchStoreName: ''
    }

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式',
        apiId,
        columns,
        // showImage: true,
        // showUploadFile: true,
        showStates: false,
        showOperation: data.key === 'menuToPromo' ? false : true,
        pagination: true,
        isAutomaticRefresh: true,
        showLogger: {
            logger: {
                id: 'menuOpLogger'
            },
            loggerDisplay: data.key === 'menuToPromo' ? false : true,
            loggerSingleDisplay: data.key === 'menuToPromo' ? false : true,
            loggerQueryType: 'menu',
            // loggerQueryTypeExtendId: localStorage.getItem("currentBranchStoreId")
            loggerQueryTypeExtendId: contextData?.currentBranchStoreId
        },
        showDelete: sessionStorage.getItem('isAdmin') === 'true' ? true : false,
        showAdd: false,
        EditComponent: MenuFoodEdit,
        // arrayFilesName: 'menuFiles',
        // UploadFileComponent: MenuUploadFile,
        sendPageData: {
            shopTypeId: shopTypeIdData,
            menuHeadId: data.menuHeadId,
            promoCategoryId: data.promoCategoryId
        },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        },

        //子表格
        isExpandable: data.key === 'menuToPromo' ? false : true,
        expandableColumns,
        expandableDataName: 'menuSpecs',

        //多选
        rowSelection: data.key !== 'menuToPromo' ?
            {
                selectedRowKeys,
                onChange: onSelectChange,
                // selectData,
                type: "checkbox",
                // onChange: setSelectData
            } : undefined,
    };

    return (
        <>
            <AntDraggableModal
                title={data.brandName + " " + data.branchStoreName + (data.key === 'menuToPromo' ? " 【" + data.promoCategoryName + "】 推广菜式" : " 【" + data.menuHeadName + "】 菜式")}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleCancel}
                onCancel={handleCancel}
                closable={false}
                // maskClosable={false}
                width={1650}>
                <Modal
                    title={"选择迁移到哪个菜谱"}
                    open={showTransferVisible}
                    onOk={handleOk}
                    onCancel={onCloseTransfer}
                    closable={false}
                    style={{ fontSize: '20px' }}
                    okButtonProps={{ disabled: loadingData }}
                    confirmLoading={loadingData}
                    width={500}
                >
                    <Form
                        form={form}
                        name="Edit"
                        style={{ height: 450 }}
                    >
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="选择菜谱"
                                    name="menuHeadId"
                                    rules={[{ required: true, message: '请选择菜谱!' }]}>
                                    <Select
                                        mode="multiple"
                                        showSearch
                                        placeholder="选择菜谱"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) => {
                                            return true
                                        }}
                                        options={menuHeadData}>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={0}>
                                <Form.Item
                                    label="当前菜式ID"
                                    name="currentMenuId">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
                <br></br>
                <Modal
                    title={"批量操作"}
                    open={showBatchOperationVisible}
                    onOk={batchOperationOk}
                    onCancel={onCloseBatchOperation}
                    closable={false}
                    style={{ fontSize: '20px' }}
                    okButtonProps={{ disabled: loadingData }}
                    confirmLoading={loadingData}
                    width={500}
                >
                    <Form
                        form={batchOperationForm}
                        name="Edit"
                        style={{ height: 450 }}
                    >
                        <Row gutter={[8, 0]}>
                            <Col span={0}>
                                <Form.Item
                                    label="key"
                                    name="key">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item>
                                    <Alert
                                        message={"共选择了 " + selectedRowKeys.length + " 个菜式 , 进行以下批量操作"}
                                        // description="进行以下批量操作"
                                        type="success"
                                        style={{ fontSize: 30 }}
                                    />
                                </Form.Item>
                            </Col>

                            {currentBatchOperation === 'changeShopType' ?
                                <>
                                    <Col span={24}>
                                        <Form.Item
                                            label="选择菜式类别"
                                            name="shopTypeId"
                                            rules={[{ required: currentBatchOperation === 'changeShopType' ? true : false, message: '请选择菜式类别!' }]}>
                                            <Select
                                                style={{ width: 150 }}
                                                showSearch
                                                onChange={(e, option) => shopTypeSelect(e, option)}
                                                placeholder="菜式类别"
                                                optionFilterProp="children"
                                                filterOption={(input, option: any) =>
                                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                }
                                                options={shopTypeNewData}
                                            >
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={0}>
                                        <Form.Item
                                            label="分类名称"
                                            name="shopTypeName">
                                            <Input disabled={true} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={0}>
                                        <Form.Item
                                            label="短码"
                                            name="shopType_shortCode">
                                            <Input disabled={true} />
                                        </Form.Item>
                                    </Col>
                                </> : ""}

                            {currentBatchOperation === 'changeDiscount' ?
                                <>
                                    <Col span={12}>
                                        <Form.Item
                                            label="打折"
                                            name="isDiscount"
                                            valuePropName="checked"
                                            initialValue={false}>
                                            <Switch
                                                checkedChildren="打折"
                                                unCheckedChildren="不打折"
                                                onChange={(e) => handleSwitch(e, setDiscountData)}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={12}>
                                        <Form.Item
                                            label="最高折扣"
                                            name="maxDiscount"
                                            initialValue={1}
                                            rules={[{ required: currentBatchOperation === 'changeDiscount' ? true : false, message: '请输入最高折扣!' }]}
                                        >
                                            <InputNumber min={0} max={1} disabled={discountData} step={0.05} />
                                        </Form.Item>
                                    </Col>
                                </> : ""}

                            {currentBatchOperation === 'changeState' ?
                                <>
                                    <Col span={24}>
                                        <Form.Item
                                            label="状态"
                                            name="isUse"
                                            valuePropName="checked">
                                            <Switch
                                                checkedChildren="上架"
                                                unCheckedChildren="下架" disabled />
                                        </Form.Item>
                                    </Col>
                                </> : ""}

                            {currentBatchOperation === 'createMenuMemo' ?
                                <>
                                    <Col span={0}>
                                        <Form.Item
                                            label="备注"
                                            name="menuMemo">
                                            <Input />
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item
                                            label="添加备注"
                                            name="showMemo"
                                        >
                                            <Space size={[0, 8]} wrap>
                                                {menuMemoTags.map((tag, index) => {
                                                    if (tag !== '') {
                                                        if (editInputMemoIndex === index) {
                                                            return (
                                                                <Input
                                                                    key={tag}
                                                                    size="small"
                                                                    value={editInputMemoValue}
                                                                    onChange={handleEditInputMemoChange}
                                                                    onBlur={handleEditInputMemoConfirm}
                                                                    onPressEnter={handleEditInputMemoConfirm}
                                                                />
                                                            );
                                                        }
                                                        const menuMemoTagElem = (
                                                            <Tag
                                                                key={tag}
                                                                color="red"
                                                                style={{ fontSize: 15, height: 22 }}
                                                                closable={index >= 0}
                                                                onClose={() => handleCloseMemoTag(tag)}
                                                            >
                                                                {tag}
                                                            </Tag>
                                                        );
                                                        return (
                                                            menuMemoTagElem
                                                        );
                                                    }
                                                })}
                                            </Space>
                                            {inputMemoVisible ? (
                                                <Input
                                                    type="text"
                                                    size="small"
                                                    style={{ width: '150px' }}
                                                    value={inputMemoValue}
                                                    onChange={handleInputMemoChange}
                                                    onBlur={handleInputMemoConfirm}
                                                    onPressEnter={handleInputMemoConfirm}
                                                />
                                            ) : (
                                                <Tag onClick={showInputMemo}>
                                                    <PlusOutlined /> 添加
                                                </Tag>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </> : ""}
                        </Row>
                    </Form>
                </Modal>
                <br></br>
                {
                    data.key !== 'menuToPromo' ?
                        <Select
                            style={{ width: 150 }}
                            // disabled={data.key !== 'menuToPromo' ? false : true}
                            showSearch
                            defaultValue="所有类别"
                            onChange={shopTypeChange}
                            placeholder="菜式类别"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.generalEx(shopTypeData, {
                                itemName: "shopTypeName",
                                includeNull: false
                            })}
                        </Select>
                        : ""
                }

                <span>&nbsp;&nbsp;</span>
                {
                    data.key !== 'menuToPromo' ?
                        <Button type="primary" onClick={handleShopTypeSortBy}>调整类别顺序</Button>
                        : ""
                }
                <span>&nbsp;&nbsp;</span>
                {
                    data.key !== 'menuToPromo' ?
                        <Button type="primary" onClick={handleMenuSalesman}>设置销售人员销售菜式</Button>
                        : ""
                }

                {
                    data.key === 'menuToPromo' ?
                        <Button type="primary" onClick={handlePromoFood}>添加推广菜式</Button>
                        : ""
                }

                <span>&nbsp;&nbsp;</span>
                {
                    data.key !== 'menuToPromo' ?
                        sessionStorage.getItem('isAdmin') === 'true' ?
                            <Popconfirm title="将所有菜式重新整理顺序,是否执行?"
                                onConfirm={() => handleMenuSortBy()}>
                                <Button type='primary'>自动更新菜式排序</Button>
                            </Popconfirm>
                            : ""
                        : ""
                }
                <span>&nbsp;&nbsp;</span>
                {
                    data.key !== 'menuToPromo' ?
                        <Space>
                            <Dropdown.Button type="primary" menu={{ items: batchOperations, onClick: handleBatchOperation }} trigger={["hover"]}>批量</Dropdown.Button>
                        </Space>
                        : ""
                }

                <span>&nbsp;&nbsp;</span>
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal>

            {menuSpecVisible
                ? (<MenuSpec
                    closeModal={onCloseMenuSpec} data={specData} />)
                : null}

            {menuCondimentVisible
                ? (<MenuCondiment
                    closeModal={setMenuCondimentVisible} data={menuCondimentData} />)
                : null}

            {/* {menuOPLogVisible
                ? (<MenuOPLog
                    closeModal={setMenuOPLogVisible} data={menuOPLogData} />)
                : null} */}

            {shopTypeVisible
                ? (<MenuShopType
                    closeModal={onCloseMenuShopType} data={menuShopTypeData} />)
                : null}

            {menuToPromoVisible
                ? (<WarehouseToMenu
                    closeModal={onCloseMenuToPromo} data={menuToPromoData} />)
                : null}

            {menuSaleDateVisible
                ? (<MenuSaleDate
                    closeModal={onCloseMenuSaleDate} data={menuSaleDateData} />)
                : null}

            {menuSalesmanVisible
                ? (<MenuSalesman
                    closeModal={onCloseMenuSalesman} data={menuSalesmanData} />)
                : null}
        </>
    )
}